import { isQuestionCategoryVisible } from './isQuestionCategoryVisible';
import { isQuestionCategorySubscribable } from './isQuestionCategorySubscribable';

/**
 * Checks if the QA session is currently active.
 *
 * @param {Object} event - The event object containing QA activation details.
 * @return {boolean} Whether the QA session is active or not.
 */
export function isQAActive(event) {
    const { default_question_category, question_categories } = event;
    return isQuestionCategoryVisible(default_question_category) || question_categories.some((cat) => isQuestionCategoryVisible(cat) || isQuestionCategorySubscribable(cat));
}
